import { RenderTextInput } from "app/common/renderInput";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";

export default function PriceCard({
  values,
  handleChange,
  tripType,
  errors,
  handleBlur,
  touched,
  setFieldValue,
}) {
  const commissionCalculate = (paxType, paxBaseFare, paxTF, percentage) => {
    const baseFare = parseFloat(paxBaseFare) || 0;
    const totalFare = parseFloat(paxTF) || 0;
    const commissionPercentage = parseFloat(percentage) || 0;

    const discount = parseFloat(
      ((baseFare * commissionPercentage) / 100 || 0).toFixed(2)
    );
    const tds = parseFloat(((discount * 2) / 100 || 0).toFixed(2));
    const netFare = parseFloat((totalFare - discount + tds).toFixed(2));
    // const discount = (baseFare * commissionPercentage) / 100 || 0;
    // const tds = (discount * 2) / 100 || 0;

    // const netFare = totalFare - discount + tds;

    if (paxType == "ADULT") {
      setFieldValue("onwardAdultDiscount", Number(discount).toFixed(2));
      setFieldValue("onwardAdultTds", Number(tds).toFixed(2));
      setFieldValue("onwardAdultNF", Number(netFare).toFixed(2));
    } else if (paxType == "CHILD") {
      setFieldValue("onwardChildDiscount", Number(discount).toFixed(2));
      setFieldValue("onwardChildTds", Number(tds).toFixed(2));
      setFieldValue("onwardChildNF", Number(netFare).toFixed(2));
    } else {
      setFieldValue("onwardInfantDiscount", Number(discount).toFixed(2));
      setFieldValue("onwardInfantTds", Number(tds).toFixed(2));
      setFieldValue("onwardInfantNF", Number(netFare).toFixed(2));
    }

    // return netFare;
  };
  useEffect(() => {
    if (
      values.onwardAdultBF > 0 &&
      values.onwardAdultTF > 0 &&
      values.onwardAdultPercentage &&
      values.adults > 0
    ) {
      commissionCalculate(
        "ADULT",
        values.onwardAdultBF,
        values.onwardAdultTF,
        values.onwardAdultPercentage
      );
    }
  }, [
    values.onwardAdultBF,
    values.onwardAdultTF,
    values.onwardAdultPercentage,
    setFieldValue,
    values.adults > 0,
  ]);
  useEffect(() => {
    if (
      values.onwardChildBF &&
      values.onwardChildTF &&
      values.onwardChildPercentage &&
      values.child > 0
    ) {
      commissionCalculate(
        "CHILD",
        values.onwardChildBF,
        values.onwardChildTF,
        values.onwardChildPercentage
      );
    }
  }, [
    values.onwardChildBF,
    values.onwardChildTF,
    values.onwardChildPercentage,
    setFieldValue,
    values.child > 0,
  ]);
  useEffect(() => {
    if (
      values.onwardInfantBF &&
      values.onwardInfantTF &&
      values.onwardInfantPercentage &&
      values.infant > 0
    ) {
      commissionCalculate(
        "INFANT",
        values.onwardInfantBF,
        values.onwardInfantTF,
        values.onwardInfantPercentage
      );
    }
  }, [
    values.onwardInfantBF,
    values.onwardInfantTF,
    values.onwardInfantPercentage,
    setFieldValue,
    values.infant > 0,
  ]);
  return (
    <div>
      {values.adults > 0 && (
        <>
          <h5 className="text-primary" style={{ fontWeight: "bold" }}>
            ADULT :{" "}
          </h5>

          <Row className="form-row">
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Base Fare"
                name={`onwardAdultBF`}
                value={values?.onwardAdultBF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultBF}
                touched={touched.onwardAdultBF}
                required
              />
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Total Tax"
                name={`onwardAdultTAF`}
                value={values?.onwardAdultTAF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultTAF}
                touched={touched.onwardAdultTAF}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Total Fare"
                name={`onwardAdultTF`}
                value={values?.onwardAdultTF || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultTF}
                touched={touched.onwardAdultTF}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                type="text"
                display="Commission Percentage(Only Number)"
                name={`onwardAdultPercentage`}
                value={values?.onwardAdultPercentage || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultPercentage}
                touched={touched.onwardAdultPercentage}
                required
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                readOnly
                type="text"
                display="Commission/Discount"
                name={`onwardAdultDiscount`}
                value={values?.onwardAdultDiscount || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultDiscount}
                touched={touched.onwardAdultDiscount}
              ></RenderTextInput>
            </Col>
            <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
              <RenderTextInput
                readOnly
                type="text"
                display="TDS Amount"
                name={`onwardAdultTds`}
                value={values?.onwardAdultTds || ""}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.onwardAdultTds}
                touched={touched.onwardAdultTds}
              ></RenderTextInput>
            </Col>
            <Col>
              <Row>
                <Col
                  xs="12"
                  md="6"
                  lg={12}
                  style={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  {values?.onwardAdultNF > 0 && (
                    <div
                      style={{
                        fontSize: 15,
                        color: "red",
                        fontWeight: "700",
                      }}
                    >
                      Net Fare: ₹ {values?.onwardAdultNF}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </>
      )}
      {values.child > 0 && (
        <>
          <hr />
          <>
            <h5 className="text-primary" style={{ fontWeight: "bold" }}>
              CHILD :
            </h5>
            <Row className="form-row">
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Base Fare"
                  name={`onwardChildBF`}
                  value={values?.onwardChildBF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildBF}
                  touched={touched.onwardChildBF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Tax"
                  name={`onwardChildTAF`}
                  value={values?.onwardChildTAF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildTAF}
                  touched={touched.onwardChildTAF}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Fare"
                  name={`onwardChildTF`}
                  value={values?.onwardChildTF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildTF}
                  touched={touched.onwardChildTF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Commission Percentage(Only Number)"
                  name={`onwardChildPercentage`}
                  value={values?.onwardChildPercentage || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildPercentage}
                  touched={touched.onwardChildPercentage}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="Commission/Discount"
                  name={`onwardChildDiscount`}
                  value={values?.onwardChildDiscount || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildDiscount}
                  touched={touched.onwardChildDiscount}
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="TDS Amount"
                  name={`onwardChildTds`}
                  value={values?.onwardChildTds || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardChildTds}
                  touched={touched.onwardChildTds}
                ></RenderTextInput>
              </Col>
              <Col>
                <Row>
                  <Col
                    xs="12"
                    md="6"
                    lg={12}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {values?.onwardChildNF > 0 && (
                      <div
                        style={{
                          fontSize: 15,
                          color: "red",
                          fontWeight: "700",
                        }}
                      >
                        Net Fare: ₹ {values?.onwardChildNF}
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        </>
      )}
      {values.infant > 0 && (
        <>
          <hr />
          <>
            <h5 className="text-primary" style={{ fontWeight: "bold" }}>
              INFANT :
            </h5>
            <Row className="form-row">
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Base Fare"
                  name={`onwardInfantBF`}
                  value={values?.onwardInfantBF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantBF}
                  touched={touched.onwardInfantBF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Tax"
                  name={`onwardInfantTAF`}
                  value={values?.onwardInfantTAF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantTAF}
                  touched={touched.onwardInfantTAF}
                  required
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Total Fare"
                  name={`onwardInfantTF`}
                  value={values?.onwardInfantTF || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantTF}
                  touched={touched.onwardInfantTF}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  type="text"
                  display="Commission Percentage(Only Number)"
                  name={`onwardInfantPercentage`}
                  value={values?.onwardInfantPercentage || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantPercentage}
                  touched={touched.onwardInfantPercentage}
                  required
                ></RenderTextInput>
              </Col>

              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="Commission/Discount"
                  name={`onwardInfantDiscount`}
                  value={values?.onwardInfantDiscount || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantDiscount}
                  touched={touched.onwardInfantDiscount}
                ></RenderTextInput>
              </Col>
              <Col xs="12" md="6" lg={tripType == 2 ? "6" : "4"}>
                <RenderTextInput
                  readOnly
                  type="text"
                  display="TDS Amount"
                  name={`onwardInfantTds`}
                  value={values?.onwardInfantTds || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.onwardInfantTds}
                  touched={touched.onwardInfantTds}
                ></RenderTextInput>
              </Col>
              <Col>
                <Row>
                  <Col
                    xs="12"
                    md="6"
                    lg={12}
                    style={{
                      justifyContent: "flex-end",
                      display: "flex",
                    }}
                  >
                    {values?.onwardInfantNF > 0 && (
                      <div
                        style={{
                          fontSize: 15,
                          color: "red",
                          fontWeight: "700",
                        }}
                      >
                        Net Fare: ₹ {values?.onwardInfantNF}
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        </>
      )}
    </div>
  );
}
